









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AddressAttribute } from '@/store/models';
import store from '@/store';
import getValidationRules from '@/commons/formFieldValidationRules';
import { getPrefix, getTelephoneWithoutPrefix } from '@/commons/telephonePrefix';

@Component({})
export default class TelephonePrefixField extends Vue {
    @Prop() public addressAttribute!: AddressAttribute;
    @Prop() public modelValue!: string;

    public telephonePrefix = getPrefix(this.modelValue);
    public telephoneWithoutPrefix = getTelephoneWithoutPrefix(this.modelValue);

    get options() {
        return store.state.countryData.countries;
    }

    get validationRules() {
        const addressAttribute = { ...this.addressAttribute };
        addressAttribute.code = 'telephone-without-prefix';
        return getValidationRules(addressAttribute);
    }

    @Watch('telephonePrefix')
    @Watch('telephoneWithoutPrefix')
    public updateModelValue() {
        this.$emit('updateModelValue', [this.telephonePrefix + this.telephoneWithoutPrefix, 'telephone-prefix']);
    }
}
